import { Layout } from '@/components/layout';
import {
  HeroSection,
  WhyChooseSection,
  BrandsSection,
  FeaturedProducts,
  AthleteTrustSection,
  ReviewsSection,
  CTASection,
} from '@/components/home';

const HomePage = () => {
  return (
    <Layout>
      <HeroSection />
      <FeaturedProducts />
      <WhyChooseSection />
      <BrandsSection />
      <AthleteTrustSection />
      <ReviewsSection />
      <CTASection />
    </Layout>
  );
};

export default HomePage;
